const state = {
  donasi: [],
  donasi_id: [],
};

export default state;
